<template>
    <div v-if="profile" class="text-xs-center">
        <v-avatar class="ma-3" size="125px">
            <img
            class="img-circle elevation-7 mb-1"
            :src="profile.picture"
            >
        </v-avatar>
    </div>
    <v-progress-circular v-else indeterminate :size="65"/>
</template>

<script>
import { firestore, auth, storage, ui, uiConfig } from "@/firebase";
export default {
  props: {
    id: String
  },
  data() {
    return {
      profile: null
    };
  },
  mounted() {
    this.bind(this.id);
  },
  watch: {
    id(id) {
      this.bind(id);
    }
  },
  methods: {
    bind(id) {
      if (this.id) {
        this.$bind("profile", firestore.collection("users").doc(id));
      }
    }
  },
  computed: {
    firstName() {
      return this.profile && this.profile.name
        ? this.profile.name.split(" ")[0]
        : "";
    },
    lastName() {
      return this.profile &&
        this.profile.name &&
        this.profile.name.split(" ").length > 1
        ? this.profile.name.split(" ")[1]
        : "";
    }
  }
};
</script>

